import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import './accessBusinessControl.css';
import { addBusiness } from '../../../../redux/businessesSlice';
import { notifyError, notifySuccess } from '../../../Notification';
import { fetchUsers } from '../../../../redux/usersSlice';

const AddBusinessModal = ({ email, onClose }) => {
    const [newBusinessName, setNewBusinessName] = useState('');
    const [selectedBusinessId, setSelectedBusinessId] = useState('');
    const [newBusinessInput, setNewBusinessInput] = useState(true);
    const [selectedBusinessInput, setSelectedBusinessInput] = useState(true);
    const [newBusinessAdded, setNewBusinessAdded] = useState(false);
    const [submitClicked, setSubmitClicked] = useState(false);

    const dispatch = useDispatch();
    const { items: businesses, loading, error } = useSelector((state) => state.businesses);


    const handleNewBusinessNameChange = (e) => {
        setNewBusinessName(e.target.value.toUpperCase());
    };
    
    // set selectedBusinessInput true when setNewBusinessName is not empty
    useEffect(() => {
        if (newBusinessName) {
            setSelectedBusinessInput(false);
        } else {
            setSelectedBusinessInput(true);
        }
    }, [newBusinessName]);

    // set newBusinessInput true when selectedBusinessId is not empty
    useEffect(() => {
        if (selectedBusinessId) {
            setNewBusinessInput(false);
        } else {
            setNewBusinessInput(true);
        }
    }, [selectedBusinessId]);

    const handleSelectBusinessId = (e) => {
        setSelectedBusinessId(e.target.value);
    };

    const handleSubmit = () => {
        if (newBusinessName) {
            // Add the new business in the Businesses table
            dispatch(addBusiness({ business_name: newBusinessName, email }))
            .unwrap() // Unwrap to catch success or error directly
                .then(() => {
                notifySuccess(businesses.message || `Business ${newBusinessName} added successfully`);
                // fetch decks 
                const userEmail = localStorage.getItem('user');
                dispatch(fetchUsers(userEmail));
                })
                .catch((error) => {
                notifyError(error || `Error adding business ${newBusinessName}`);
                })
        }
    }

            

    const handleClose = () => {
        onClose();
        if (newBusinessAdded) {
            // fetch users again
            dispatch(fetchUsers(email));
        }
        setNewBusinessAdded(false);
    }

    // render erro or success message
    useEffect(() => {
        if (error) {
            notifyError(error);
        }
    }, [error]);


    return (
        <div >
            {loading && <div className='loading'>Loading...</div>}
            <div >
                <div>
                    <div className='slide1-section-title'>Enter New Business Name:</div>
                    <input
                        className='add-business-input'
                        type="text"
                        value={newBusinessName}
                        onChange={handleNewBusinessNameChange}
                        disabled={!newBusinessInput}
                    />
                </div>
                <div className='add-business-btns-container'>
                    <button className='btn btn-primary' onClick={handleSubmit}>Submit</button>
                    <button className='btn btn-secondary-outline' onClick={handleClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default AddBusinessModal;